// https://codepen.io/brundolf/pen/dvoGyw

function collapseSection(element) {
    // get the height of the element's inner content, regardless of its actual size
    var sectionHeight = element.scrollHeight;
    // temporarily disable all css transitions
    var elementTransition = element.style.transition;
    // console.log(elementTransition);
    element.style.transition = '';

    // on the next frame (as soon as the previous style change has taken effect),
    // explicitly set the element's height to its current pixel height, so we 
    // aren't transitioning out of 'auto'
    requestAnimationFrame(function () {
        element.style.height = sectionHeight + 'px';
        element.style.transition = elementTransition;

        // on the next frame (as soon as the previous style change has taken effect),
        // have the element transition to height: 0
        requestAnimationFrame(function () {
            element.style.height = 0 + 'px';
        });
    });

    getClosest(element)
    // mark the section as "currently collapsed"
    element.setAttribute('data-collapsed', 'true');
    element.previousElementSibling.setAttribute('data-collapsed', 'true');
}



function expandSection(element) {
    element.style.height = '0px';
    // get the height of the element's inner content, regardless of its actual size
    var sectionHeight = element.scrollHeight;
    // have the element transition to the height of its inner content
    element.style.height = sectionHeight + 'px';

    getClosest(element)

    // mark the section as "currently not collapsed"
    element.setAttribute('data-collapsed', 'false');
    element.previousElementSibling.setAttribute('data-collapsed', 'false');
}

function getClosest(referenz) {
    var closest = referenz.previousElementSibling.closest(".accordion_content");
    if (closest) {
        closest.style.height = null;
        getClosest(closest)
    }
}

// Click-Event
const accordion_labels = document.querySelectorAll(".accordion_label");
for (var j = 0; j < accordion_labels.length; j++) {
    document.getElementsByClassName("accordion_label")[j].addEventListener("click", (event) => {
        var element = event.target;
        // if element is not a label - try parent
        while (element.nodeName != "LABEL") {
            var element = element.parentNode;
        }
        var section = element.nextElementSibling;
        var isCollapsed = section.getAttribute('data-collapsed') === 'true';
        var isRadio = section.getAttribute('data-radio') === 'true';
        var isOne = section.getAttribute('data-one') === 'true';

        // Skip when Element is always open
        if (element.classList.contains("accordion_always_open")) {
            return
        }

        // collapse all radiobuttons
        if (isRadio) {
            var parent_id = element.parentNode.parentNode.id;
            const radios = document.querySelectorAll("#" + parent_id + " [data-radio='true']");
            for (var i = 0; i < radios.length; i++) {
                if (section != radios[i]) {
                    if (radios[i].style.height != "0px") {
                        collapseSection(radios[i])
                    }
                }
            }
        }

        if (isCollapsed) {
            expandSection(section)
        } else {
            if (!isRadio || !isOne) {
                // set height of init-Expanded-Item
                var sollHeight = section.offsetHeight;
                section.style.height = sollHeight + "px";
                collapseSection(section);
            }
        }
    }, false);
}

// document.addEventListener('DOMContentLoaded', function () {
//     console.log("ding");
// });